/**
 * Escapes special characters of the string to use it in RegExp.
 */
export const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Returns RegExp matching the sentence that contains the given placeholder:
 * text and inline tags around it up to the sentence punctuation.
 */
export const getPlaceholderSentenceRegExp = (placeholder) => {
  const sentencePart = '(?:[^.!?<>]|<\\/?(?:strong)\\b[^>]*>)*';
  return new RegExp(`${sentencePart}${escapeRegExp(placeholder)}${sentencePart}[.!?]?`, 'g');
};
